export const FONT_STYLE_KEY = "btt_font_style";
export const DEFAULT_FONT_STYLE = "bold";

export function getFontStyle() {
  return localStorage.getItem(FONT_STYLE_KEY) || DEFAULT_FONT_STYLE;
}

export function applyFontStyle(style) {
  document.documentElement.dataset.fontStyle = style;
  localStorage.setItem(FONT_STYLE_KEY, style);
}
